import SendunitPool from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    sendunitPools: [],
    filteredCollection: [],
    current: new SendunitPool()
  },
  getters: {
    getCollection: state => state.sendunitPools,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.sendunitPools.find(sendunitPool => sendunitPool.id === id),
    getCurrent: state => state.current
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/sendunitPools',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((sendunitPool) => {
            commit('addSendunitPoolToCollection', { sendunitPoolData: sendunitPool })
            return getters.getById(sendunitPool.id)
          })

          commit('addSendunitPoolToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/sendunitPools',
        data: model.getJSON()
      }).then((res) => {

        commit('addSendunitPoolToCollection', { sendunitPoolData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/sendunitPools/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addSendunitPoolToCollection', { sendunitPoolData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/sendunitPools/' + id
      }).then((res) => {

        commit('removeSendunitPoolFromCollection', id)

        return res
      })
    }
  },
  mutations: {
    addSendunitPoolToCollection(state, { sendunitPoolData, opts }) {
      addToCollection(this, state.sendunitPools, sendunitPoolData, SendunitPool, opts)
    },
    addSendunitPoolToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeSendunitPoolFromCollection(state, sendunitPoolId) {
      const index = state.sendunitPools.findIndex(el => el.id === sendunitPoolId)

      if (index === -1) {
        console.warn(`Could not find/delete sendunitPool ${sendunitPoolId}`)
        return
      }

      state.sendunitPools.splice(index, 1)
    },
    clearCollection(state) {
      state.sendunitPools = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, sendunitPool) {
      state.current = sendunitPool
    },
    resetCurrent (state) {
      state.current = new SendunitPool()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sendunitPool/store.js